import financeiroApi from '../financeiroApi';

const PATH = '/api/v1/backend/fiscal/indicador-operacao-ibs-cbs';

export default {
  buscarIndicadorOperacaoIbsCbs: async (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  pesquisarIndicadorOperacaoIbsCbs: async (params) => {
    return financeiroApi.get(`${PATH}/pesquisar`, { params });
  },
};
